<template>
  <div class="v2-history v2-container v2-section">
    <header class="v2-history__header">
      <p class="v2-overline">Membresía</p>
      <h1 class="v2-headline v2-headline--display-lg v2-history__title">
        Histórico y Pagos
      </h1>
      <p class="v2-body v2-body--md v2-body--muted">
        Consulta tu historial de facturas, membresías, cursos, eventos y pagos pendientes.
      </p>
    </header>

    <div class="v2-history__legacy">
      <MemberHistoricLegacy />
    </div>
  </div>
</template>

<script>
import MemberHistoricLegacy from "@/views/memberDashboard/memberHistoric.vue";

export default {
  name: "MemberDashboardV2History",
  components: { MemberHistoricLegacy },
};
</script>

<style scoped>
.v2-history {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.v2-history__header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.v2-history__title {
  margin: 0;
}

.v2-history__legacy {
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  overflow-x: auto;
}
</style>
